<template>
  <div class="flex flex-col min-h-screen font-inter bg-neutral-100 text-neutral-600">
    <!-- 顶部通知栏 -->
    <div class="bg-primary text-white text-center py-2 text-sm">
      <p>限时优惠：全场商品8折起 | 满299元免运费 
        <span class="hidden md:inline">| 新用户注册立减50元</span>
      </p>
    </div>

    <!-- 导航栏 -->
    <Header />

    <!-- 主要内容 -->
    <main class="flex-grow container mx-auto px-4 py-8">
      <router-view />
    </main>

    <!-- 页脚 -->
    <Footer />

    <!-- Cookie提示 -->
    <div v-if="showCookieNotice" class="fixed bottom-0 left-0 right-0 bg-neutral-800 text-white p-4 z-50">
      <div class="container mx-auto flex flex-col md:flex-row justify-between items-center">
        <p class="text-sm mb-4 md:mb-0">
          我们使用Cookie来提升您的购物体验。继续使用我们的网站即表示您同意我们的
          <router-link to="/cookie-policy" class="text-primary hover:underline">Cookie政策</router-link>。
        </p>
        <button @click="showCookieNotice = false" 
                class="bg-primary hover:bg-primary/90 text-white px-6 py-2 rounded-full transition-all">
          我知道了
        </button>
      </div>
    </div>
    
    <!-- 全局消息提示 -->
    <Message ref="message" />
  </div>
</template>

<script>
import Header from './Header.vue'
import Footer from './Footer.vue'
import Message from '../Common/Message.vue'

export default {
  name: 'MainLayout',
  components: {
    Header,
    Footer,
    Message
  },
  data() {
    return {
      showCookieNotice: true
    }
  },
  mounted() {
    // 检查是否已接受Cookie
    const cookieAccepted = localStorage.getItem('cookieAccepted')
    if (cookieAccepted) {
      this.showCookieNotice = false
    }
    
    // 监听全局消息事件
    this.$bus.$on('showMessage', (options) => {
      if (typeof options === 'string') {
        this.$refs.message.show({ message: options })
      } else {
        this.$refs.message.show(options)
      }
    })
  },
  watch: {
    showCookieNotice(newVal) {
      if (!newVal) {
        localStorage.setItem('cookieAccepted', 'true')
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('showMessage')
  }
}
</script>